import { useState, useLayoutEffect } from 'react'

import { InputCheck } from '../../../../../../../../Forms/InputCheck'
import { useCouponRules } from '../../../couponRulesContext'

import { Container } from './style'


export function Product({ product }) {
    const { 
        productsSelectedsToLink, 
        setProductsSelectedsToLink 
    } = useCouponRules()

    const [checked, setChecked] = useState(false)

    function handleClickCheckboxProduct() {  
        setChecked(state => !state)

        if(!checked)
            checkProductFromGroup()
        else
            uncheckProductFromGroup()
    }

    function checkProductFromGroup() {
        setProductsSelectedsToLink(list => [...list, product.idProduct])
    }

    function uncheckProductFromGroup() {
        setProductsSelectedsToLink(oldList =>  oldList.filter(pdct => pdct !== product.idProduct))
    }

    useLayoutEffect(() => {
        if(!!productsSelectedsToLink.length) {
            setChecked(productsSelectedsToLink.includes(product.idProduct))
        
            return
        }

        setChecked(false)

        //eslint-disable-next-line
    }, [productsSelectedsToLink])

    
    return (
        <Container>
            <InputCheck 
                checked={checked}
                handleClick={handleClickCheckboxProduct}
                size={1.2}
            />
            <p>{product.name}</p>
        </Container>
    )
}